import { createStore, RequestStatus } from "common-frontend-components";
const { useStore, set, get } = createStore({
    getDefaultValues: () => ({
        photos: {},
        photoList: [],
        imageFullViewUrl: undefined,
        requestStatus: RequestStatus.pending,
    })
});
const setFullView = (imageFullViewUrl) => set({ imageFullViewUrl: imageFullViewUrl || undefined });
export const galleriesFullViewStore = {
    getFullView: () => get().imageFullViewUrl,
    setFullView,
    useFullView: () => useStore(s => s.imageFullViewUrl),
    openFullView: (imageFullViewUrl) => setFullView(imageFullViewUrl),
    closeFullView: () => setFullView(undefined),
};
//# sourceMappingURL=galleriesFullViewStore.js.map